module.exports = __webpack_public_path__ + "static/media/MonthView.ecd899e2.svg";